/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-05-25 13:19:23
 * @modify date 2021-05-25 13:19:23
 * @desc [description]
 */
const React = require('react');
const PropTypes = require('prop-types');
const Loading = require('$/components/Loading');

const LoadingPage = () => {
  return (
    <Loading fullScreen>
      Loading page...
    </Loading>
  );
};

const PreloadWrapper = (props) => {
  const { component: Component, injectProps } = props;
  return <Component {...injectProps} />;
};
PreloadWrapper.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  injectProps: PropTypes.shape({}).isRequired,
};

const Preload = (params) => {
  const { loader, loading: LoadingComponent, delay } = params;
  return (props) => {
    const [component, setComponent] = React.useState(null);
    const [failed, setFailed] = React.useState(false);
    const [attempt, setAttempt] = React.useState(0);

    React.useEffect(() => {
      let isMounted = true;
      setFailed(false);
      const timeoutHandle = setTimeout(() => {
        Promise.resolve().then(loader).then((_model) => {
          if (isMounted) {
            setComponent(() => _model.default); // it fixes a bug for React
          }
        }).catch(() => {
          if (isMounted) setFailed(true);
        });
      }, delay || 0);

      return () => {
        isMounted = false;
        clearTimeout(timeoutHandle);
      };
    }, [loader, delay, attempt]);

    if (failed) {
      return (
        <Loading fullScreen error onRetry={() => { setFailed(false); setAttempt((value) => value + 1); }}>
          This page could not be loaded. Check your connection and try again.
        </Loading>
      );
    }

    if (!component) {
      return <LoadingComponent />;
    }

    const ComponentClass = component;
    return <PreloadWrapper component={ComponentClass} injectProps={props} />;
  };
};

const pages = {};
pages.playground = Preload({
  loader: () => import('./playground'),
  loading: LoadingPage,
});

pages.googleOAuthCodeReceiver = Preload({
  loader: () => import('./google-oauth-code-receiver'),
  loading: LoadingPage,
});

pages.playground__webgl_view = Preload({
  loader: () => import('./playground__webgl_view'),
  loading: LoadingPage,
});

pages.session_terminated = Preload({
  loader: () => import('./session_terminated'),
  loading: LoadingPage,
});

pages.create_room = Preload({
  loader: () => import('./create_room'),
  loading: LoadingPage,
});

pages.entrance = Preload({
  loader: () => import('./entrance'),
  loading: LoadingPage,
});

pages.homepage = Preload({
  loader: () => import('./homepage'),
  loading: LoadingPage,
});

pages.work = Preload({
  loader: () => import('./work'),
  loading: LoadingPage,
});

pages.verifyEmail = Preload({
  loader: () => import('./verify_email'),
  loading: LoadingPage,
});

pages.recover = Preload({
  loader: () => import('./recover'),
  loading: LoadingPage,
});

pages.error404 = Preload({
  loader: () => import('./error404'),
  loading: LoadingPage,
});

module.exports = pages;
